<template>
  <div class="custom-overlay">
    <div class="h-full" style="background-color: #f0f2f5">
      <slot></slot>
      <div class="copy-right">
        <copy-right-footer />
      </div>
    </div>
  </div>
</template>

<script>
import CopyRightFooter from 'components/dygc-footer-bottom'
export default {
  name: 'CustomOverlay',
  components: { CopyRightFooter }
}
</script>
<style scoped lang="scss">
.custom-overlay {
  .copy-right {
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
  }
}
</style>
